import { useQuery } from "@tanstack/react-query";
import { getUserContactInfo, UserContactInfo } from "../../../resource/bff";
import { FormOption } from "../component/DeliveryInformationForm/UserDetailForm/UserDetailForm";

const formatRes = (userContactInfo: UserContactInfo) => {
  return {
    ...userContactInfo,
    homeAddress: (userContactInfo.homeAddress ?? []).map((address) => ({
      ...address,
      optionTitle: `${address.mailingAddress} (Home Address)`,
    })) as FormOption[],
  };
};

export const useGetUserContactInfoFromWDAsync = (ifSendRequest: boolean) => {
  const { refetch, error, data, isFetching, isLoading } = useQuery(
    ["userContactInfo", ifSendRequest],
    () => getUserContactInfo().then((res: any) => formatRes(res)),
    { cacheTime: Infinity, enabled: ifSendRequest }
  );
  return {
    isLoading,
    refetch,
    error,
    data,
    isFetching,
  };
};
